import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { City, CustomBaseStore } from '@city/const';
import { CityService } from '@city/feature';
import { SdModal, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import { combineLatest, map, Observable } from 'rxjs';
import { CitySearchComponent } from '../city-search';
import { NoDeliveryMessageComponent } from '../no-delivery-message';

@Component({
  selector: 'sd-cities-dialog',
  templateUrl: './cities-dialog.component.html',
  styleUrls: ['./cities-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SdvorIconComponent, NoDeliveryMessageComponent, CitySearchComponent],
})
export class CitiesDialogComponent implements OnInit {
  isDesktop$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  baseStores$: Observable<CustomBaseStore[]>;
  filteredBaseStores: CustomBaseStore[] = [];
  currentCity$: Observable<City | undefined>;
  iconType = IconTypes;

  constructor(
    private cityService: CityService,
    private sdModal: SdModal,
    private deviceService: DeviceService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.baseStores$ = this.cityService.baseStores$;
    this.currentCity$ = this.cityService.currentCity$;

    this.baseStores$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((stores) => {
      this.filteredBaseStores = stores;
    });

    combineLatest([this.baseStores$, this.currentCity$])
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(([stores, currentCity]) => {
          if (!currentCity) return stores;

          return this.sortedStores(stores, currentCity);
        }),
      )
      .subscribe((sortedStores) => {
        this.filteredBaseStores = sortedStores;
      });
  }

  onSelectBaseStore(slug: string): void {
    this.sdModal.close();
    this.cityService.setBaseStore(slug);
  }

  onFilterBaseStores(filteredStores: CustomBaseStore[]): void {
    this.filteredBaseStores = filteredStores;
  }

  private sortedStores(stores: CustomBaseStore[], currentCity: City): CustomBaseStore[] {
    return stores.sort((a, b) => {
      if (a.name === currentCity.name) return -1;
      if (b.name === currentCity.name) return 1;

      if (a.isMain && !b.isMain) return -1;
      if (!a.isMain && b.isMain) return 1;

      return 0;
    });
  }
}
